import { formatContactLocation } from "features/results/utils/contactOrEmail";

import style from "./HealthMailContactOption.module.css";

/**
 * One directory entry in an Autocomplete list. Names repeat (many "Boots …", doctors
 * sharing a name), so the address and county sit under the name to tell them apart.
 */
export const HealthMailContactOption = ({ optionProps, contact }) => {
  const { key, ...rest } = optionProps;
  const location = formatContactLocation(contact);

  return (
    <li key={key} {...rest}>
      <span className={style.option}>
        <span className={style.name}>{contact.name}</span>
        {!!location && <span className={style.location}>{location}</span>}
      </span>
    </li>
  );
};
